import { TextField } from '@mui/material';

import { GDMTextFieldComponent } from './GDMTextField.type';

/* TODO: Implement component using GDM default design */
const GDMTextField: GDMTextFieldComponent = props => <TextField {...props} />;

export default GDMTextField;
